import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Validation from '../container/Validation.js';

export default class Input extends Component{
	constructor(props){
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.handleNumber = this.handleNumber.bind(this);
	}

	handleChange(e){
		let input = e.target.value;
		this.props.onInput(this.props.identity,input);
	}

	handleNumber(e){
		let input = e.target.value;
		if(this.props.identity !== "price" && Validation("posInteger",input)){
			input = input.replace(/\-/g,"");
			if(this.props.identity !== "price"){
				input = input.replace(/\./g,"");
			}
			let validInput = input ===''?input:Number(input);
			this.props.onInput(this.props.identity,validInput);
		}else if(this.props.identity === "price" && /^(\s*|[0]{1}|[1-9][0-9]*)(\.\d{0,2})?$/.test(input)){
			input = input.replace(/\-/g,"");
			let validInput = input;
			this.props.onInput(this.props.identity,validInput);
		}
	}

	render(){
		let textBox;
		if(this.props.type === "area"){
			textBox = <textarea className={this.props.styles} maxLength="1000" onChange={this.handleChange} id={this.props.id} value={this.props.val} placeholder={this.props.placeholder}></textarea>;
		}else if(this.props.type === "number"){
			textBox = <input className={this.props.inputStyle} placeholder={this.props.placeholder} type="text" id={this.props.id} onChange={this.handleNumber} value={this.props.val}/>;
		}else if(this.props.type === "file"){
			textBox = <input className={this.props.inputStyle} placeholder={this.props.placeholder} type="file" id={this.props.id} onChange={this.handleChange} value={this.props.val}/>
		}else if(this.props.type === "password"){
			textBox = <input className={this.props.inputStyle} onKeyDown={this.props.onKeyDown} placeholder={this.props.placeholder} type="password" id={this.props.id} onChange={this.handleChange} value={this.props.val}/>;
		}else{
			textBox = <input className={this.props.inputStyle} placeholder={this.props.placeholder} type="text" id={this.props.id} onChange={this.handleChange} value={this.props.val}/>;
		}
		return(
				<div className={this.props.boxStyle}>
					{textBox}
				</div>
		);
	}
}

Input.defaultProps = {
  type: 'text'
};

Input.propTypes = {
	type: PropTypes.string,
	val: PropTypes.any,
	palceholder: PropTypes.string,
	id: PropTypes.string,
	styles: PropTypes.string,
	inputStyle: PropTypes.string,
	handleChange: PropTypes.func,
	handleNumber: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/component/Input.js